import type { ArticleSeriesTopConfig } from 'interfaces/content/articles/Articles';
import Link from 'components/Globals/Base/Link';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import { IndexInfo, Wrapper, Title } from './ArticleSeriesTopStyles';

const ArticleSeriesTop = ({ seriesID, series, articleURL, className, dataCy }: ArticleSeriesTopConfig) => {
  const { name, posts } = series;
  const totalInSeries = posts?.length;
  let pathname: string;
  if (!name || !totalInSeries) return null;
  try {
    pathname = new URL(articleURL, 'https://fortune.com').pathname;
  } catch {
    return null;
  }
  const positionInSeries = posts.findIndex((element) => element.uri === pathname) + 1;
  return (
    <Wrapper
      className={className}
      data-cy={dataCy}
    >
      <IndexInfo aria-label={`Article ${positionInSeries} out of ${totalInSeries} in the series`}>
        {positionInSeries}/{totalInSeries}
      </IndexInfo>
      <Title>
        Part of -
        <Link
          href={`#${seriesID}`}
          type='bluePrimary'
        >{` ${name}`}</Link>
      </Title>
    </Wrapper>
  );
};

export default withErrorBoundary(ArticleSeriesTop, { fragment: UIFragments.ARTICLE_SERIES });
